export const NUX_TEMPLATE_NAME = 'NUX Guided Creation Template';
export const NUX_SITE_NAME = 'Create basic layouts';
export const TUTORIAL_RESUME_QUERY_PARAM = 't_s'; // t_s = tutorial section

type NuxTemplate = {
  name: string;
  type: string;
  cost: number;
  starter: boolean;
  tutorial?: string;
};

export const nuxTemplate: NuxTemplate = {
  name: NUX_TEMPLATE_NAME,
  type: 'basic',
  cost: 0,
  starter: false,
};

type NuxTutorialType = {
  ID: 'nux-flexbox-extended';
};

export const NUX_FLEXBOX_EXTENDED: NuxTutorialType = {
  ID: 'nux-flexbox-extended',
};
